// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PPUe","newExpiryDate":"styles_newExpiryDate__1rrKl","footer":"styles_footer__3Zd61"};